import { all_roles } from '@/utils';
import { Materials } from '@/modules/marketing_materials/types';

const access_roles = {
  [Materials.Pages.MATERIALS]: all_roles,
};

export default access_roles;
